// extracted by mini-css-extract-plugin
export default {"section":"ocT5Gr","mobileBreakline":"GuE3MS"};